export function disableNextButton() {
  document.querySelector('.btn-next').classList.add('btn-disabled');
}
export function enableNextButton() {
  document.querySelector('.btn-next').classList.remove('btn-disabled');
}

export function toggleNextButton(inputSelector) {
  if (document.querySelectorAll(inputSelector).length) {
    document.querySelector('.btn-next').classList.remove('btn-disabled');
  } else {
    document.querySelector('.btn-next').classList.add('btn-disabled');
  }
}

export function protectNextButtonByRadio(inputName) {
  const inputSelector = 'input[name=' + inputName + ']';
  const selectedInputSelector = inputSelector + ':checked';
  toggleNextButton(selectedInputSelector);

  document.querySelectorAll(inputSelector).forEach(input => {
    input.addEventListener('change', () => {
      toggleNextButton(selectedInputSelector);
    });
  });
}

export function initAccordions(accordionClassName = 'accordion-container') {
  const accordions = Array.from(document.getElementsByClassName(accordionClassName));
  const accordionsInited = {};

  // initiate accordions
  for (let [index, accordion] of accordions.entries()) {
    const defaultOpened = Array.from(accordion.children)
      .filter(item => item.classList.contains('accordion-opened-default')) // find items with opened as default class
      .map(item => Array.prototype.indexOf.call(item.parentNode.children, item)); // get index in the parent node
    const acc = new Accordion(accordion, {
      showMultiple: true,
      openOnInit: defaultOpened, // pass items that should be expanded as default
      onOpen: () => {
        window.dispatchEvent(new Event('resize')); // enables reaction for page height change (e.g. bottom bar)
      },
      onClose: () => {
        window.dispatchEvent(new Event('resize')); // enables reaction for page height change (e.g. bottom bar)
      },
    });
    const indexName = `${accordionClassName}-${index}`;
    accordion.dataset.accordionIndex = indexName;
    accordionsInited[indexName] = acc;
  }

  // expand accordions to reveal already selected product
  const selectedInput = document.querySelectorAll(
    '.product-wrapper > input:checked, .product-wrapper > input.product-input-field:not([value=""]'
  );
  openAccordionsBySelectedValues(selectedInput, accordionsInited);
  return accordionsInited;
}

export function openAccordionsBySelectedValues(selectedInputs, accordionsInited) {
  if (selectedInputs.length) {
    const accordionsToBeOpened = [];
    selectedInputs.forEach(selectedInput => {
      let elem = selectedInput;
      let nextToCheck = elem.parentNode;
      while (nextToCheck && nextToCheck.nodeName.toLowerCase() !== 'body') {
        // for all the accordion page items find out their parent accordion and index within
        if (nextToCheck.classList.contains('ac')) {
          const accordionPage = nextToCheck;
          const accordionElem = nextToCheck.parentNode;
          const indexInParent = Array.prototype.indexOf.call(accordionElem.children, accordionPage);
          if (accordionElem.dataset.accordionIndex !== undefined) {
            accordionsToBeOpened.push({
              accordionId: accordionElem.dataset.accordionIndex,
              itemToBeOpened: indexInParent,
            });
          }
        }

        nextToCheck = nextToCheck.parentNode;
      }
    });

    // open corresponding accordions
    for (let accordionConfig of accordionsToBeOpened) {
      if (accordionsInited[accordionConfig.accordionId]) {
        accordionsInited[accordionConfig.accordionId].open(accordionConfig.itemToBeOpened);
      }
    }
  }
}

export function closeAccordions(accordionsInited) {
  for (let accordion of Object.values(accordionsInited)) {
    accordion.closeAll();
  }
}